<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div *ngIf="!landscape" class="main-form-container">
    <div style="gap: 1rem" class="d-flex flex-column col-6">
      <div>
        <ng-container *ngTemplateOutlet="floors"></ng-container>
      </div>
      <div class="form-line-p">
        <ng-container *ngTemplateOutlet="mduFlag"></ng-container>
      </div>
      <div>
        <ng-container *ngTemplateOutlet="buildingType"></ng-container>
      </div>
    </div>
    <div class="d-flex flex-column col-6">
      <ng-container *ngTemplateOutlet="units"></ng-container>
    </div>
  </div>
  <div *ngIf="landscape" class="main-form-container gap-4">
    <div class="d-flex flex-column col-4">
      <ng-container *ngTemplateOutlet="floors"></ng-container>
    </div>
    <div class="d-flex flex-column col-4">
      <ng-container *ngTemplateOutlet="units"></ng-container>
    </div>
    <div class="d-flex flex-column col-4 gap-4">
      <div class="form-line">
        <ng-container *ngTemplateOutlet="mduFlag"></ng-container>
      </div>
      <div>
        <ng-container *ngTemplateOutlet="buildingType"></ng-container>
      </div>
    </div>
  </div>
  <div class="address-wrapper">
    <app-survey-frame-list
      *ngFor="let address of survey.building.addresses; let i = index"
    >
      <app-survey-frame-list-template [id]="address.id" [index]="i">
        <div class="templateHeader address-container" header>
          <div class="d-flex align-items-center">
            <mat-icon
              style="color: red; margin-right: 0.5rem"
              *ngIf="getErrors(address.id)"
              >warning</mat-icon
            >
            <span class="key">
              <span i18n="@@general.units.address">Address</span>
              <span> {{ i + 1 }}</span>
              <div class="keyNumber" *ngIf="address.lomKey">
                {{ address.lomKey }}
              </div>
              <div class="keyNumber text-center" *ngIf="!address.lomKey">-</div>
            </span>
            <span class="address">{{ address.getFullAddress() }}</span>
          </div>
          <div class="type">
            {{ addressTypeEnum[address.addressType] }}
            <span *ngIf="address.addressType == addressTypeEnum.StudentHome">
              ({{ address.studentHomeCount }})
            </span>
          </div>
        </div>
        <div
          [ngClass]="landscape ? 'col-6' : 'col-12'"
          class="address-details-container"
          detail
        >
          <form [formGroup]="unitForms[survey.building.id]">
            <div style="width: 100%; gap: 1rem" class="d-flex">
              <div style="width: 100%" class="d-flex flex-column">
                <div class="subtitle-wrapper">
                  <mat-icon
                    style="color: red"
                    *ngIf="
                      getErrors(
                        address.id,
                        outsideUnitsEnum.ADDRESS_CHARACTERISTIC_FIELD
                      )
                    "
                    >warning
                  </mat-icon>
                  <div
                    class="address-type required upper-text titleText"
                    i18n="@@general.addresstype"
                  >
                    Address Characteristic
                  </div>
                </div>
                <div
                  [ngClass]="{
                    'invalid-answer-input': getErrors(
                      address.id,
                      outsideUnitsEnum.ADDRESS_CHARACTERISTIC_FIELD
                    )
                  }"
                >
                  <p-dropdown
                    [options]="addressTypesForBuilding"
                    [formControlName]="'addressType' + i"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="_"
                    appendTo="body"
                    [disabled]="!this.isAuthCanWrite"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div style="width: 100%">
                <div
                  *ngIf="
                    unitForms[survey.building.id].get('addressType' + i) &&
                    unitForms[survey.building.id].get('addressType' + i)
                      .value == addressTypeEnum.StudentHome
                  "
                  class="inputStudent d-flex flex-column"
                >
                  <div class="subtitle-wrapper">
                    <mat-icon
                      style="color: red"
                      *ngIf="
                        getErrors(
                          address.id,
                          outsideUnitsEnum.NUMBER_OF_ROOMS_FIELD
                        )
                      "
                      >warning
                    </mat-icon>
                    <div
                      class="titleText required"
                      i18n="@@general.units.nrofRooms"
                    >
                      The number of rooms
                    </div>
                  </div>
                  <div
                    class="input-wrapper"
                    [ngClass]="{
                      'invalid-answer-input': getErrors(
                        address.id,
                        outsideUnitsEnum.NUMBER_OF_ROOMS_FIELD
                      )
                    }"
                  >
                    <input
                      style="border-width: 1px"
                      class="form-control"
                      type="number"
                      min="0"
                      [attr.disabled]="!this.isAuthCanWrite ? '' : null"
                      [formControlName]="
                        'address' + address.id + studentHomeCountKey
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </app-survey-frame-list-template>
    </app-survey-frame-list>
  </div>
</div>

<ng-template #floors>
  <div class="subtitle-wrapper">
    <mat-icon
      *ngIf="getErrors(outsideUnitsEnum.FLOORS_FIELD)"
      style="color: red"
      >warning
    </mat-icon>
    <div class="titleText required" i18n="@@general.floors">Floors</div>
  </div>
  <div
    [ngClass]="{
      'invalid-answer-input': getErrors(outsideUnitsEnum.FLOORS_FIELD)
    }"
  >
    <app-unit-info
      *ngFor="let unitInfoQuestion of floorQuestions"
      [unitType]="unitInfoQuestion.label"
      [currentValue]="unitInfoQuestion.quantity"
      [minValue]="0"
      [maxValue]="100"
      (currentValueChange)="onQuantityChange($event, unitInfoQuestion.key)"
      [isDisabled]="!this.isAuthCanWrite"
    >
    </app-unit-info>
  </div>
</ng-template>

<ng-template #mduFlag>
  <span i18n="@@general.mduflag" class="question"> MDu Flag </span>
  <p-checkbox
    [ngModel]="validateMDuFlag"
    [binary]="true"
    [disabled]="true"
  ></p-checkbox>
</ng-template>

<ng-template #buildingType>
  <div class="subtitle-wrapper">
    <mat-icon
      style="color: red"
      *ngIf="getErrors(outsideUnitsEnum.BUILDING_CHARACTERISTIC_FIELD)"
      >warning
    </mat-icon>
    <div class="titleText required" i18n="@@general.buildingtype">
      Building Characteristic
    </div>
  </div>
  <div class="action">
    <form [formGroup]="unitForms[survey.building.id]">
      <div
        [ngClass]="{
          'invalid-answer-input': getErrors(
            outsideUnitsEnum.BUILDING_CHARACTERISTIC_FIELD
          )
        }"
      >
        <p-dropdown
          [options]="buildingTypesDuringOutsideSurvey"
          formControlName="buildingType"
          (onChange)="onChange($event)"
          optionLabel="label"
          optionValue="value"
          placeholder="_"
          scrollHeight="300px"
          [disabled]="!this.isAuthCanWrite"
        ></p-dropdown>
      </div>
      <div
        style="margin-top: 0.75rem"
        *ngIf="
          unitForms[survey.building.id].get('buildingType') &&
          unitForms[survey.building.id].get('buildingType').value ==
            buildingTypeEnum.StudentHome
        "
      >
        <div class="subtitle-wrapper">
          <mat-icon
            style="color: red"
            *ngIf="getErrors(outsideUnitsEnum.NUMBER_OF_ROOMS_FIELD)"
            >warning
          </mat-icon>
          <div class="titleText required" i18n="@@general.units.nrofRooms">
            The number of rooms
          </div>
        </div>
        <div
          class="input-wrapper"
          [ngClass]="{
            'invalid-answer-input': getErrors(
              outsideUnitsEnum.NUMBER_OF_ROOMS_FIELD
            )
          }"
        >
          <input
            style="border-width: 1px"
            class="form-control"
            type="number"
            min="0"
            [attr.disabled]="!this.isAuthCanWrite ? '' : null"
            [formControlName]="'building' + studentHomeCountKey"
          />
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #units>
  <div class="subtitle-wrapper">
    <mat-icon style="color: red" *ngIf="getErrors(outsideUnitsEnum.UNITS_FIELD)"
      >warning
    </mat-icon>
    <div class="titleText required" i18n="@@general.units">Units (initial)</div>
  </div>
  <div class="wrapper-total-units">
    <div
      *ngFor="let unitInfoQuestion of unitQuestions"
      [ngClass]="{
        'invalid-answer-input': getErrors(outsideUnitsEnum.UNITS_FIELD)
      }"
    >
      <app-unit-info
        [unitType]="unitInfoQuestion.label"
        [currentValue]="unitInfoQuestion.quantity"
        [minValue]="0"
        [maxValue]="1000"
        [originalValue]="unitInfoQuestion.originalValue"
        (currentValueChange)="onQuantityChange($event, unitInfoQuestion.key)"
        [isDisabled]="!this.isAuthCanWrite"
      >
      </app-unit-info>
    </div>
    <div class="totalUnitFrame">
      <div i18n="@@general.totalUnits">Total Units</div>
      <div style="font-size: 16px">
        {{ totalUnits }}
      </div>
    </div>
  </div>
</ng-template>
